/** @flow */

import React from "react";
import { localize } from "redux-i18n";
import { Modal, ModalHeader, ModalBody, Button, ModalFooter, Col, SchemaForm } from "@components";
import type { EmployeeAbsenceInteraction } from "@modules/shared/reducer/employee-absences/types";
import uiSchema from "./ui-schema";

type Props = $Exact<{
  ...PropsFromLocalize,
  interaction: ?EmployeeAbsenceInteraction,
  onDismissHandler: () => void,
  onSubmit: (formData: Object) => void,
}>;

export class EditInteractionModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  submitHandler = (formData: Object) => {
    this.props.onSubmit(formData);
  };

  get schema() {
    return {
      type: "object",
      required: ["notes", "id"],
      properties: {
        id: {
          type: "integer",
          title: "Employee Absence Call Interaction",
        },
        notes: {
          type: "string",
          title: "Notes",
        },
      },
      urn:
        "urn:jsonschema:eu:firstcare:api:v1:dto:employee:admin:absence:EmployeeAbsenceCallInteractionDTO",
    };
  }

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader toggle={this.props.onDismissHandler}>
          {this.props.t("INTERACTION")}
        </ModalHeader>
        <ModalBody>
          <Col sm={{ size: 8, offset: 2 }}>
            <SchemaForm
              externalSubmit
              schema={this.schema}
              formData={this.props.interaction}
              uiSchema={uiSchema}
              ref={this.formRef}
              onSubmit={this.submitHandler}
            />
          </Col>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(EditInteractionModal);
